module.exports = __webpack_public_path__ + "img/Kfc Chicken Nuggets.285d1d68.png";